// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_checkout_page_root__TRorG"};